<label class="obg-m-session-limit-item-current-limit" *ngIf="currentLimitText"
	>{{ currentLimitText | jurisdiction | translate }}
	<span *ngIf="currentLimitValue; else notset"
		>{{ currentLimitValue }} {{ "multi-session-limit.current-limit.hours" | jurisdiction | translate }}</span
	>
	<ng-template #notset>
		<span>{{ "general.not-set" | translate }}</span>
	</ng-template>
</label>

<div *ngIf="showInputField && control" class="obg-m-session-limit-item-input">
	<span *ngIf="!hideIconAndSuffix" [ngClass]="[iconName]" class="obg-m-session-limit-item-icon ico"></span>
	<mat-form-field [floatLabel]="!!inputLabel ? 'always' : 'never'">
		<mat-label *ngIf="!!inputLabel">{{ inputLabel | translate }}</mat-label>
		<input
			matInput
			type="tel"
			[placeholder]="placeholder | translate"
			[formControl]="control"
			[autofocus]="autoFocus"
			autocomplete="off"
			#sessionInput
			[required]="isSessionLimitItemRequired ? true : null"
		/>
		<span *ngIf="!hideIconAndSuffix" class="obg-m-session-limit-item-input-suffix">{{
			inputSuffix | jurisdiction | translate
		}}</span>
		<mat-hint
			*ngIf="!hideInputHint && limitSuggestion && !(control.invalid && (control.touched || control.dirty))"
			attr.test-id="{{ suggestionTestId }}"
		>
			{{ "multi-session-limit.suggestion" | jurisdiction | translate }}: {{ limitSuggestion }}
			{{ inputSuffix | jurisdiction | translate }}
		</mat-hint>
	</mat-form-field>
	<obg-common-validation-renderer
		*ngIf="!hideValidator"
		[input]="control"
		[translationPrefix]="translationPrefix"
	></obg-common-validation-renderer>
</div>
